import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { isValidElement } from 'react';
import Box from '@mui/material/Box';
const Left = React.forwardRef((_props, _ref) => null);
Left.displayName = 'TopBarLayout.Left';
const Center = React.forwardRef((_props, _ref) => null);
Center.displayName = 'TopBarLayout.Center';
const Right = React.forwardRef((_props, _ref) => null);
Right.displayName = 'TopBarLayout.Right';
const Layout = (props) => {
    const { children } = props;
    const childrenArray = React.Children.toArray(children).filter(isValidElement);
    const left = childrenArray.find((child) => child.type === Left);
    const center = childrenArray.find((child) => child.type === Center);
    const right = childrenArray.find((child) => child.type === Right);
    return (_jsx(Box, { component: "header", sx: {
            px: { xs: 2, md: 3 },
            // py: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
        }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', width: '100%', gap: 2, minHeight: '2.75rem' }, children: [_jsx(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.5, flex: '0 0 auto' }, ref: left?.props.ref, children: left?.props.children }), _jsx(Box, { sx: { flex: '1 1 auto' } }), _jsx(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1.5,
                        flex: '0 1 auto',
                    }, ref: center?.props.ref, children: center?.props.children }), _jsx(Box, { sx: { flex: '1 1 auto' } }), _jsx(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: 1.5,
                        flex: '0 0 auto',
                    }, ref: right?.props.ref, children: right?.props.children })] }) }));
};
export const TopBarLayout = Object.assign(Layout, { Left, Center, Right });
